<template>
  <div class="content homebg">
    <div class="row homeherow">
      <div class="homehero column" style="margin:auto;">

        <div class="marketline" style="margin:40px 0 0 5px;">
          <router-link to="/platform" style="color: #ccc;">
            Focus and clarity for founders and small teams
          </router-link>
        </div>

        <h1 id="h1home">
          <router-link to="/contact" class="h1home-link">
            <span style="font-weight:400; color: #fff;text-shadow: #000 0px 0px 20px;">
              Get focused on what matters most.
            </span>
          </router-link>
        </h1>

        <div class="signupfree" style="margin-top:20px;">
          <p>
            <router-link to="/platform">
              <button class="btn-home-pink">Learn More</button>
            </router-link>
            <router-link to="/contact">
              <button class="btn-home-blue">Get a Demo</button>
            </router-link>
          </p>
        </div>

        <p class="h1home-p">
            Foclarity helps founders, solopreneurs, and small teams turn scattered priorities into clear scorecards, aligned action, and measurable progress.
        </p>
        <p class="h1home-p">
          <strong>Use AI to support the work, not distract from it.</strong>
        </p>

        <!-- use the modal component, pass in the prop -->
        <modal v-if="showModal" @close="showModal = false">
          <template v-slot:header>
            <h3>How Foclarity Works</h3>
          </template>
          <template v-slot:body>
            <p>
              <strong>Clarify</strong> the priorities that matter most.
            </p>
            <p>
              <strong>Build</strong> a practical scorecard around outcomes and ownership.
            </p>
            <p>
              <strong>Align</strong> the people responsible for moving each priority forward.
            </p>
            <p>
              <strong>Execute</strong> with AI-assisted tasks and next steps that keep momentum going.
            </p>
          </template>
          <template v-slot:footer>
            <p>Less chaos. More traction.</p>
          </template>
        </modal>                
      </div>

      <div class="column">
        <div class="inlinebubble1"></div>
      </div>
   
    </div>

    <div class="bottom-banner">
      <p>
        Focus on the right things. Follow through with confidence.
      </p>
    </div>

    <div class="panel max homebluedk" style="margin-top:10px !important;" v-show="false">
      <div class="row middled" style="max-width: 1200px;">
        <div class="column" style="justify-content:center;max-width:800px;min-width:300px;margin:auto;">
          <div style="padding:20px;">
            <h3 style="line-height:1.5em;color:#ddd;">
              &ldquo;We leaned into Foclarity to help Simmitri Solar identify, track, and reach our most audacious scaling and revenue goals.
            The results came much faster than expected, not to mention our team communication across all departments improved greatly as a result.&rdquo;
            </h3>
            <p style="color:#ccc;">
              Dan Jenkin<br>
              Executive VP, Simmitri Solar
            </p>
          </div>
        </div>
        <div class="column">
          <div class="inlinebubble2">
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { isLoggedIn } from "../utils/auth";
import modal from "@/components/includes/InfoModal"
import { userService } from '../_services';
// import OnboardingChat from '@/components/includes/OnboardingChat.vue';

export default {
  title: 'Focus, Clarity and Alignment for Founders and Small Teams | Foclarity',
  description: 'Foclarity helps founders, solopreneurs, and small teams turn scattered priorities into clear scorecards, aligned action, and measurable progress.',
  name: "Home",
  mounted: function() {
    if (isLoggedIn()) {
      this.$router.push("dashboards");
    } else {
      // this.pollPerson() ;
      this.pollquote() ;
    }
    // window.setInterval(()=>{
    //   this.pollPerson();
    // }, 5000);
  },
  data () {
      return {
        showModal: false,
        showOnboarding: false,
        submitted: false,
        email: '',
        error: '',
        showthis: false,
        purpon: 0,
        personas: ['...',
        'lack of focus?',
        'lack of clarity?',
        'lack of alignment?',
        'focus and clarity.'],
        personas3: ['...',
        'Drive growth.',
        'Streamline operations.',
        'Improve alignment.',
        'Manage change.',
        'Get focus & clarity.'
        ],
        pullquote: '',
        personas2: ['...', 'Building a startup?', 'Raising money?', 'Finding customers?', 'Growing your business?', '...', 'Accelerate through the unknowns...', 'Get focus, clarity, and alignment.'],
        persona: 'Executives',
        head1: 'Slowed down by',
        looper: 0,
        qloop: 0,
        equotes: ['I’m falling short of my growth targets, what can I do?',
                  'Can I make better investment tradeoffs, within and across functions and products?',
                  'How do I get my executive team more focused on the biggest challenges and opportunities?',
                  'How do we better manage the growing set of demands, needs, and wants?',
                  'How do we refine our strategy and direction without undermining the foundation we have?',
                  'How can we get sales, marketing and engineering on the same page and on the same team?',
                  'How can we better segment our customer base, get better product-market fit and accelerate market traction?',
                  'How do I make sure we are spending time and resources on the right potential customers?',
                  'How can we overcome the many barriers to gaining the right champions and closing deals?',
                  'Is there a better way to position the company and ‘go to market’?',
                  'Is there a better business model to monetize the value we provide customers and partners?',
                  'How can we better scale our business, and better utilize scarce field sales, support and marketing resources?',
                  'Is there a way to go ‘deeper’ and ‘broader’, with fewer bigger deals and many more smaller deals?',
                  'How can we better communicate our strategy, solutions and plans to employees and key stakeholders?',
                  'Are we doing too much?']
      }
  },
  methods: {
    isLoggedIn() {
      return isLoggedIn();
    },
    goto: function (path) {
      this.$router.push(path);
    },
    purploop() {
      // count to 5 then stop
      this.purpon ++ ;
      if (this.purpon > 3) {
        this.purpon = 1;
      }
      setTimeout(this.purploop, 2000);
    },
    pollquote() {
      this.qloop ++ ;
      // first set pullquote to empty
      const first = this.equotes.shift();
      this.equotes = this.equotes.concat(first);
      this.pullquote = this.equotes[0];
      // set a timer to run this function again in 5 seconds
      setTimeout(this.pollquote, 5000);
    },
    pollPerson(){
      // count to 5 then stop
      this.looper ++ ;
      // first set persona to empty
      const first = this.personas.shift();
      this.personas = this.personas.concat(first);
      this.persona = ''

      // untype
      const typeEffectDown = () => {
        if (this.persona.length == 1) {
          this.persona = ""
          if (this.looper == 3) {
            this.head1 = 'Accelerate with'
          }
          setTimeout(this.pollPerson, 200);
        } else {
          this.persona = this.persona.slice(0, -1);
          setTimeout(typeEffectDown, 50);
        }
      }

      // type
      const typeEffect = () => {
        if (this.persona.length === this.personas[0].length) {
          if (this.looper == 4) {
            return ;
          }
          setTimeout(typeEffectDown, 2000);
        } else {
          if (this.persona.length < this.personas[0].length) {
          this.persona += this.personas[0].charAt(this.persona.length);
          setTimeout(typeEffect, 50);
          } 
        }
      }

      typeEffect();
    },
    analyzeWebsite: function() {
      this.submitted = true;
      this.error = 'Processing...'
      const { email } = this;

      // stop here if form is invalid
      if (!(email)) {
        this.submitted = false ;
        this.error = 'Please enter a work email'
        return;
      }

      userService.checksite(email)
          .then(
              // eslint-disable-next-line no-unused-vars
              message => {
                this.error = 'Check your email for details.' ;
                this.email = '' ;
              },
              error => {
                this.error = error ;
                this.submitted = false ;
                this.email = '' ;
              }
          );
    }

  },
  components: {
    modal
  },
  created () {
    this.purploop() ;
  }
};
</script>

<style lang="scss" scoped>
.homebg {
  // background: #fff url("~@/assets/homebg-gray@2x-80.jpg")no-repeat top right ; 
  // background: linear-gradient(236deg, #2c0059, #07f4f1 22%, #31bff6 48%, #9a35fe 86%, #923dfd);
  //background: linear-gradient(rgba(0, 24, 68, 0.7), rgba(0, 24, 68, 1)),  url("~@/assets/bg_lines.jpg")no-repeat top center ;
  background: linear-gradient(#07061e, #07061e00 23%), radial-gradient(circle at 50% -30%, #0a0828 58%, #2e1973 68%, #582ecc 83%, #a081f5 98%, #b197f5 103%);
  -webkit-background-size: contain;
  -moz-background-size: contain;
  -o-background-size: contain;
  background-size: contain;
  @media only screen and (max-width: 440px) {
    background-position-x: top right;
    background-size: 300%;
  }
  .homeherow {
    max-width:1300px;
    margin:auto;
    min-height: 690px;
    @media only screen and (max-width: 440px) {
      min-height: 600px;
    }
  }
}
.homehero {
  padding: 0 0 0 27px ;
  max-width: 1200px ;
  min-width: 300px;
  margin-left:auto;
  margin-right:auto;
  & h1 {
    margin:40px 0 70px 0;
    max-width: 600px ;
    //color:#CC0099;
  }
  & h2 {
    margin: 10px 0;
    font-family: 'Lato', Arial, Helvetica, sans-serif ;
    font-size: 1.8rem;
  }
  & a {
    text-decoration: none;
    & .signupbox {
      text-align: center;
      padding: 8px;
      background: #582ecc ;
      // background: #41495B;
      width: 250px;
      border-radius: 4px;
      color: #fff;
    }
  }
  @media only screen and (max-width: 440px) {
    & h1 {
      margin:20px 0 20px 0;
      font-size: 2rem ;
    }
    & h2 {
      margin: 20px 0;
      font-size: 1.5rem;
    }
    padding: 0px 8px ;
  }
}
.heroblue {
  background: #ffffff; //linear-gradient(110deg, #00b2ee 60%, #007cee 60%);
  min-height: 320px;
  margin: -20px -20px 20px -20px;
  border-radius: 4px 4px 0 0;
  @media only screen and (max-width: 440px) {
    border-radius: 0px 0px 0 0;
  }
  display: flex;
  align-items: center;
  justify-content: center;
  & h1 {
    text-align: center;
    color: #333;
    font-size: 45px;
    max-width: 600px;
    @media (max-width: 500px) {
      font-size: 36px;
      padding: 20px;
    }
  }
}
.marketline {
  font-size: 1rem;
  text-transform: uppercase;
  letter-spacing: 2px;
  // color: #2E5077;
  color: #fff;
  & a {
    text-decoration: none;
    color: #fff;
    // color: #2E5077;
  }
  font-weight: 800;
  text-align: left;
  @media (max-width: 500px) {
      text-align: center;
    }
}

.quotebubble {
  color:#fff;
  // border:10px solid #2E5077;
  // border:15px solid #f3bc45;
  // background:#fff url("~@/assets/home-screenshot.jpg") no-repeat top left;
  // background:#fff url("~@/assets/dylan-web.jpg") no-repeat top left;
  // background:#fff url("~@/assets/radar-web.jpg") no-repeat top left;
  // background:#000 url("~@/assets/dall-e-nyt-execs.png") no-repeat top left;
  // background:#000 url("~@/assets/circle-image-friends.jpg") no-repeat top left;
  // background:#fff url("~@/assets/foclarity-sample-dashboard2.jpg") no-repeat top center;
  // background:#fff url("~@/assets/dashboards-sample.png") no-repeat top center;
  // background-size:cover;
  padding:0px;
  border-radius:50%;
  // width:400px;
  // height:400px;
  text-align:center;
  margin: auto;
  @media (max-width: 500px) {
    // border:4px solid #2E5077;
    padding:20px 0px;
    margin: 0 auto 20px ;
    // border-radius:0%;
    // width:300px;
    // height:300px;
  }
}

.inlinebubble1 {
  // color:#fff;
  // border:10px solid #582ecc; //004466?
  background:transparent url("~@/assets/Foclarity-bot.png") no-repeat 50% 50%;
  // background:#000 url("~@/assets/girl-coached.jpg") no-repeat top left;
  // background:#000 url("~@/assets/circle-image-friends.jpg") no-repeat top left;
  // background:#fff url("~@/assets/radar-web.jpg") no-repeat top left;
  // background:#000 url("~@/assets/dall-e-nyt-execs.png") no-repeat top left;
  background-size:contain;
  // padding:40px;
  // border-radius:0 20% 20% 20%;
  width:100%;
  height:100%;
  // text-align:center;
  margin: auto;
  @media (max-width: 500px) {
    // border:10px solid #582ecc;
    padding:20px 10px;
    // border-radius:0%;
    width:300px;
    height:300px;
  }
}

.inlinebubble2 {
  color:#fff;
  border:10px solid #582ecc;
  background:#000 url("~@/assets/simmitri-logo.png") no-repeat 50% 50%;
  background-size:80%;
  padding:40px;
  border-radius:50%;
  width:370px;
  height:370px;
  text-align:center;
  margin: 10px auto;
  @media (max-width: 500px) {
    border:10px solid #582ecc;
    padding:20px 10px;
    // border-radius:0%;
    width:300px;
    height:300px;
  }
}

.announcement {
  background: #582ecc;
  // background: #ffa600;
  text-align: center;
  color: #fff;
  left:0;
  top:0;
  z-index: 10000;
  // fixed location at the top of the page
  position: fixed;
  width: 100%;
  // margin:-10px -20px 0 -20px;
  padding: 10px;
  & a {
    color: #fff;
    text-decoration:none;
    font-size: .8em;
    line-height: 1.5em;
  }
}

.homemods {
  margin-top:40px !important;
}

.signupfree {
  max-width:600px;
  margin-bottom:10px;
  line-height:1.2em;
  text-align: left;
  & #btn-home-consultant {
    background: #fff;
    border:1px solid #ffaa00;
    color:#ffaa00;
    margin: 0 0 20px 0;
    padding:10px 20px;
  }
  & #btn-home-executive {
    background: #582ecc;
    border:1px solid #582ecc;
    margin: 0 20px 20px 0;
    padding:10px 20px;
  }
  & .btn-home-pink {
    background: #582ecc;
    border:1px solid #582ecc;
    color:#fff;
    margin: 0 10px 20px 0;
    padding:10px 20px;
  }
  & .btn-home-blue {
    background: #23a6d5;
    border:1px solid #23a6d5;
    box-shadow: #23a6d5 0 0 30px;
    color:#fff;
    margin: 0 10px 20px 0;
    padding:10px 20px;
  }
  & .btn-home-white {
    background: transparent;
    border:1px solid #fff;
    color:#fff;
    margin: 0 5px 20px 5px;
    padding:10px 20px;
  }
  @media (max-width: 500px) {
    margin-bottom:0px;
    text-align: center;
    & #btn-home-consultant, #btn-home-executive, #btn-home-demo, .btn-home-white, .btn-home-blue, .btn-home-pink {
      margin: 10px ;
      width:90%;
    }
  }

}

.subtype {
  padding-right: 5px;
  white-space: nowrap;
  color:#582ecc;
}

.bottom-banner {
  text-align:center;
  margin:20px -20px -10px -20px;
  // max-width:1200px;
  padding:20px 20px 2px;
  vertical-align:middle;
  // background: #4DA1A9;
  // border: 1px solid #2E5077;
  // background: #d6ebff;
  // background: #2E5077;
  background: #07061e;
  // border-radius: 40px;
  color: #ffffff;
  & p {
    // text-transform: uppercase;
    font-weight: 700;
    font-size: 1em;
    line-height: 1.5em;
  }
}

.bluish {
  background: #fff;
  background: linear-gradient(180deg, #edf6ff 0%, #ffffff 50%);
}

.purp {
  color: #582ecc;
}

.button-row {
  display: flex;
  gap: 16px;
  justify-content: center;
  align-items: center;
  margin-bottom: 1em;
}
.button-row a {
  display: inline-block;
}
@media (max-width: 600px) {
  .button-row {
    flex-direction: column;
    gap: 8px;
  }
}

.foclarity-icp-panel {
  background: linear-gradient(100deg, #f7f2fa 80%, #e9d6fa 100%);
  border-radius: 12px;
  margin-top: 32px;
  margin-bottom: 32px;
  box-shadow: 0 4px 24px 0 rgba(191,0,255,0.07), 0 1.5px 8px 0 rgba(191,0,255,0.04);
  border: none;
  padding: 0;
}
.foclarity-icp-row {
  max-width: 1100px;
  margin: 0 auto;
  padding: 0 12px;
}
.foclarity-icp-col {
  justify-content: center;
  max-width: 700px;
  min-width: 300px;
  margin: auto;
  @media screen and (max-width: 700px) {
    max-width: 100%;
    padding: 0 20px;
    
  }
}
.foclarity-icp-inner {
  // padding: 36px 32px 32px 32px;
  position: relative;
}
.foclarity-icp-lead {
  font-size: 1.18em;
  color: #5a3a7a;
  max-width: 650px;
  margin: 0 0 24px 0;
  font-weight: 500;
  line-height: 1.5;
}
.foclarity-icp-box {
  background: #fff;
  // border-left: 6px solid #2E5077;
  // border-right: 6px solid #2E5077;
  // border-radius: 8px;
  // box-shadow: 0 2px 8px 0 rgba(191,0,255,0.04);
  padding: 20px 28px 18px 24px;
  margin: 0 0 18px 0;
  max-width: 650px;
}
.foclarity-icp-box strong {
  color: #582ecc;
  font-size: 1.08em;
  letter-spacing: 1px;
}
.foclarity-icp-box ul {
  margin: 10px 0 0 18px;
  padding: 0;
  font-size: 1.05em;
  & li {
    margin: 0 0 8px 0;
    line-height: 1.5em;
    font-weight: 500;
    color: #5a3a7a;
  }
}
.foclarity-painpoints-box {
  background: #fff;
  border: 4px solid #582ecc;
  border-radius: 8px;
  padding: 16px 24px 12px 18px;
  color: #41037b;
  font-size: 1.05em;
  font-weight: bold;
  line-height: 1.5em;
  box-shadow: 0 1px 4px 0 rgba(122,79,163,0.04);
}
.foclarity-painpoints-box ul {
  margin: 0 0 0 18px;
  padding: 0;
  font-weight: 500;
  a {
    color: #582ecc;
    text-decoration: none;
  }
}
@media (max-width: 700px) {
  .foclarity-icp-inner {
    padding: 18px 6px 18px 6px;
  }
  .foclarity-icp-box, .foclarity-painpoints-box {
    padding: 14px 10px 10px 10px;
    font-size: 1em;
  }
}

.homebluedk {
  // background: #2c0059 ;
  background: linear-gradient(#07061e, #07061e00 23%), radial-gradient(circle at 50% -30%, #0a0828 58%, #2e1973 68%, #582ecc 83%, #a081f5 98%, #b197f5 103%);
  // background: linear-gradient(-45deg, #ee7752, #e73c7e, #23a6d5, #23d5ab);
  // background: #ffcbf8;
  // border-top: 4px solid #CC0099 ;
  // border-bottom: 4px solid #CC0099 ;
  &.colorfull {
    background: linear-gradient(-45deg, #ee7752, #e73c7e, #23a6d5, #23d5ab);
    background-size: 400% 400%;
    animation: gradient 15s ease infinite;
  } 
  @keyframes gradient {
    0% {
        background-position: 0% 50%;
    }
    50% {
        background-position: 100% 50%;
    }
    100% {
        background-position: 0% 50%;
    }
  }
}
.btn-home-blue {
    background: #002EFF;
    border:1px solid #002EFF;
    box-shadow: #002EFF 0 0 30px;
    color:#fff;
    margin: 0 5px 20px 0;
    padding:10px 20px;
    @media (max-width: 500px) {
      width: 100%; 
    }   
  }
</style>
